import { DEFAULT_SCHOOL_OPTIONS } from '../../config/settingsConfig';
import { ClassAccess } from '../../types/adminConfig';
import { type SchoolSettings } from '../../types/apiTypes';
import { ConfigIngestModes, Permission } from '../../types/recordingTypes';

export const classSettingsDemoData: SchoolSettings = {
    domains: '',
    has_app: false,
    has_lms: true,
    has_chat: true,
    has_zoom: false,
    zoom_app_id: 'user',
    allow_pmi: true,
    host_title: 'instructor',
    vanity_url: '',
    class_notes: false,
    enable_log_auto_upload: true,
    has_panic_mode: false,
    has_surveys: true,
    has_polling: true,
    has_web_app: true,
    force_web_app_chromebooks: true,
    has_document: true,
    roster_title: 'roster',
    has_gradebook: true,
    document_title: 'syllabus',
    has_proctoring: true,
    has_share_files: false,
    has_whiteboard: true,
    students_title: 'student',
    gradebook_title: 'gradebook',
    has_assessments: true,
    has_assignments: true,
    assistants_title: 'assistant',
    proctoring_title: 'proctoring_view',
    organization_type: 'academic',
    show_meeting_info: true,
    send_invite_emails: true,
    auto_transcriptions: false,
    recording_auto_save: false,
    recording_cloud_save: false,
    recording_local_save: false,
    recording_participants_can_download: true,
    forced_authentication: false,
    has_lose_focus_tracking: true,
    join_class_by_meeting_id: true,
    prompt_students_for_feedback: false,
    prompt_teachers_for_feedback: true,
    notify_outdated_class_version: false,
    enforce_class_minimum_version: true,
    recording_interactive_player: true,
    recording_initial_permission: Permission.ROSTER,
    recording_ingest_mode: ConfigIngestModes.TRACK,
    recording_participants_can_view: false,
    recording_restrict_gallery: false,
    recording_tab_access: ClassAccess.All,
    attendance_tab_access: ClassAccess.All,
    restrict_sessions_recordings_by_groups: true,
    auto_verify: 'never',
    has_google: false,
    has_ms_office: true,
    has_ai_ta: false,
    class_access: ClassAccess.All,
    allow_instructor_swap: false,
    enable_breakout_room_cloud_recording: true,
    prevent_leave_session_redirect: false,
    enable_breakout_room_security: false,
    whiteboard_screenshot_feature: false,
    instructor_chat_download: false,
    is_bb_data: false,
    data_portal_admin: false,
    data_portal_business_analyst: false,
    data_portal_class_business_analyst: false,
    data_portal_customer_support: true,
    data_portal_instructor: false,
    data_portal_student: false,
    allow_ai_for_support: false,
    allow_ai_for_insights: false,
    azure_tenant_id: null,
    has_azure_phone_numbers: false,
    options: DEFAULT_SCHOOL_OPTIONS,
    overrides: {}
};
